import { createApp } from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';
import 'ant-design-vue/dist/antd.less';
import './scss/iconfont.css';
import './scss/fonticon/iconfont.css';
import './scss/fonticon2/iconfont.css';
import './scss/fonticon3/iconfont.css';
import lazyPlugin from 'vue3-lazy';
import VueQr from 'vue-qr/src/packages/vue-qr.vue'
import vueRouter from './router/index.js';
import store from './store/index';
createApp(App)
.use(Antd)
.use(vueRouter)
.use(store)
.use(VueQr)
.use(lazyPlugin, {
    loading: require('@/assets/img/wxPng.png'), // 图片加载时默认图片
    error: require('@/assets/img/wxPng.png')// 图片加载失败时默认图片
  })
.mount('#app')
